import { render, staticRenderFns } from "./pending-card-email-model.vue?vue&type=template&id=827f7a7a&scoped=true&"
import script from "./pending-card-email-model.vue?vue&type=script&lang=js&"
export * from "./pending-card-email-model.vue?vue&type=script&lang=js&"
import style0 from "./pending-card-email-model.vue?vue&type=style&index=0&id=827f7a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f7a7a",
  null
  
)

export default component.exports